import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import useAxios from "../../../../api/useAxios";
import {
  Table,
  TableContainer,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Card,
  Tooltip,
  TablePagination,
  Grid,
  Typography,
  Paper,
  Switch,
  Fab,
  Chip,
  TableSortLabel,
  Skeleton,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  InputLabel,
} from "@mui/material";
import {
  CheckRounded as CheckRoundedIcon,
  RefreshSharp as RefreshSharpIcon,
} from "@mui/icons-material/";
import { ReactComponent as Warning } from "../../../../img/admin-panel/warning-circle-svgrepo-com.svg";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import defaultimg from "../../../../img/addefaultimage.jpg";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment/moment";
import "jspdf-autotable";
import ExportCS from "../../../admin-panel/admin-components/ExportComponents/ExportCS.js";
import ExportPDF from "../../../admin-panel/admin-components/ExportComponents/ExportPDF.js";
import { useContext } from "react";
import DeleteIcon from "@mui/icons-material/Delete";

function AdminAdvertisementSettings() {
  const [getApi, setGetApi] = useState([]);
  const [useApi, setUseApi] = useState([]);
  const [page, setPage] = useState(0);
  const [filterPosition, setFilterPosition] = useState("");
  const [loading, setLoading] = useState({ isLoading: true, dialogLoad: true });

  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [getOne, setGetOne] = useState("");
  const [getOneAdDetails, setGetOneAdDetails] = useState([]);

  const [startdisabled, setstartdisabled] = useState(false);
  const [enddisabled, setenddisabled] = useState(false);
  const [dateenable, setdateenable] = useState(true);
  // <!----SORt--->
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [searchicon, setsearchicon] = useState(false);

  const [confirmCloseAd, setConfirmCloseAd] = useState(false);
  const [openAd, setOpenAd] = useState(false);
  const [starterror, setstartError] = useState(null);
  const [enderror, setendError] = useState(null);
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [openDelete, setOpenDelete] = useState(false);
  const snack = JSON.parse(sessionStorage.getItem("seeker-setting"));
  const axiosData = useAxios();
  const baseUrl = axiosData.defaults.baseURL;
  const minDate = moment("01-06-2023", "DD-MM-YYYY");
  const maxDate = moment();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleStartDateChange = (date) => {
    setStartDate(date);
    setstartError(null);
  };
  const handleEndDateChange = (date) => {
    setEndDate(date);
    setendError(null);
  };
  const fetchApi = async () => {
    try {
      const useAxiosData = await axiosData.get(`advertisement`);
      const { data } = useAxiosData;
      data.reverse();
      if (useAxiosData.status === 204) {
        setGetApi([]);
      } else {
        setGetApi(data);
        handleClickFilter(data, startDate, endDate);
        setsearchicon(true);
        setPage(page);
      }
      setLoading({ ...loading, isLoading: false });
    } catch (err) {
      console.log("Error", err);
    }
  };
  const starterrorMessage = React.useMemo(() => {
    switch (starterror) {
      case "maxDate": {
        return `Please select a date before the end date`;
      }
      case "minDate": {
        return `Please select a date before the end date`;
      }
      case "invalidDate": {
        return "Invalid date range";
      }
      default: {
        return "";
      }
    }
  }, [starterror]);
  const enderrorMessage = React.useMemo(() => {
    switch (enderror) {
      case "maxDate": {
        return `Please select today date or before the today date`;
      }
      case "minDate": {
        return `Please select a date after the start date`;
      }
      case "invalidDate": {
        return "Invalid date range";
      }
      default: {
        return "";
      }
    }
  }, [enderror]);
  const handleClickFilter = (data, startdate, enddate) => {
    const filteredData = data.filter((d) => {
      const date = moment(d.createdDate, "DD-MM-YYYY");
      const start = moment(startdate).subtract(1, "days");
      return date.isBetween(start, enddate, null, "[]");
    });
    if (filterPosition === "") {
      setUseApi(filteredData);
      setsearchicon(true);
      setTotalRows(filteredData.length);
      setPage(0);
    } else {
      const filteredData2 = filteredData.filter(
        (d) => d.image_position === filterPosition
      );
      setUseApi(filteredData2);
      setsearchicon(true);
      setTotalRows(filteredData2.length);
      setPage(0);
    }
  };
  const handleSelectPosition = (data, positionData) => {
    const filteredData1 = data.filter((d) => {
      const date = moment(d.createdDate, "DD-MM-YYYY");
      const start = moment(startDate).subtract(1, "days");
      return date.isBetween(start, endDate, null, "[]");
    });
    const filteredData = filteredData1.filter(
      (d) => d.image_position === positionData
    );
    setUseApi(filteredData);
    setsearchicon(true);
    setTotalRows(filteredData.length);
    setPage(0);
  };
  useEffect(() => {
    fetchApi();
    setFilterPosition("");
  }, []);
  const handleClickRefresh = (data) => {
    setStartDate(moment());
    setEndDate(moment());
    setstartdisabled(false);
    setenddisabled(false);
    setstartError(null);
    setendError(null);
    handleClickFilter(data, moment(), moment());
  };
  const updateASettings = async (check, id) => {
    if (check === false) {
      try {
        const useAxiosData2 = await axiosData.put(`advertisement/${id}`, {
          status: "Close",
        });
        const { data } = useAxiosData2;
        data.reverse();
        if (useAxiosData2.status === 204) {
        } else {
          fetchApi();
        }
        setLoading({ ...loading, isLoading: false });
      } catch (err) {
        console.log("Error", err);
      }
    } else {
      try {
        const useAxiosData3 = await axiosData.put(`advertisement/${id}`, {
          status: "Open",
        });
        const { data } = useAxiosData3;
        data.reverse();
        if (useAxiosData3.status === 204) {
        } else {
          fetchApi();
        }
        setLoading({ ...loading, isLoading: false });
      } catch (err) {
        console.log("Error", err);
      }
    }
  };
  const selectedApiForExcel = useApi.map((i) => {
    return {
      "Company URL": i.company_url,
      "Advertisement Position": i.image_position,
      "Days Validity": i.days_conut,
      "Payment Amount": i.payment_amount,
      "Created Date": i.createdDate,
      Status: i.status,
    };
  });
  const headers = [
    [
      "Company URL",
      "Advertisement Position",
      "Days Validity",
      "Payment Amount",
      "Created Date",
      "Status",
    ],
  ];
  const datas = useApi.map((user) => {
    return [
      user.company_url,
      user.image_position,
      user.days_conut,
      user.payment_amount,
      user.createdDate,
      user.status,
    ];
  });
  const getOneData = async (id) => {
    try {
      const getOneAxios = await axiosData.get(`advertisement/${id}`);
      const { data } = getOneAxios;
      setGetOneAdDetails(data);
    } catch (err) {
      console.log("Error", err);
    }
  };
  const deleteUser = async (id) => {
    try {
      await axiosData.delete(`advertisement/${id}`);
      setOpenDelete(false);
    } catch (err) {
      console.log("Error", err);
    }
    fetchApi();
  };
  if (!loading.isLoading) {
    return (
      <>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Card sx={{ padding: "20px" }}>
            <Paper>
              <Box
                sx={{
                  padding: "20px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  backgroundColor: "#f2f2f2",
                }}
              >
                <Grid container spacing={3}>
                  {dateenable ? (
                    <Grid item xs={12} md={3} sm={12}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <Box
                          sx={{
                            width: { md: "100%", xs: "100%", sm: "100%" },
                          }}
                        >
                          <DatePicker
                            label="Start Date"
                            value={startDate}
                            format="DD-MM-YYYY"
                            onChange={handleStartDateChange}
                            onError={(newError) => {
                              setstartError(newError);
                              const boolenvalue =
                                newError === "invalidDate" ||
                                newError === "maxDate" ||
                                newError === "minDate" ||
                                (starterror === null && startDate === null)
                                  ? true
                                  : false;

                              setstartdisabled(boolenvalue);
                            }}
                            slotProps={{
                              textField: {
                                helperText: starterrorMessage,
                                required: true,
                                onFocus: () => {
                                  if (
                                    starterror === null &&
                                    startDate === null
                                  ) {
                                    setStartDate(moment());
                                    setstartdisabled(false);
                                  }
                                },
                              },
                            }}
                            // minDate={minDate}
                            maxDate={endDate || maxDate}
                          />
                        </Box>
                      </LocalizationProvider>
                    </Grid>
                  ) : null}
                  {dateenable ? (
                    <Grid item xs={12} md={3} sm={12}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <Box>
                          <DatePicker
                            label="End Date"
                            value={endDate}
                            format="DD-MM-YYYY"
                            onChange={handleEndDateChange}
                            onError={(newError) => {
                              setendError(newError);
                              const bollenerror =
                                newError === "invalidDate" ||
                                newError === "minDate" ||
                                newError === "maxDate" ||
                                (enderror === null && endDate === null)
                                  ? true
                                  : false;

                              setenddisabled(bollenerror);
                            }}
                            slotProps={{
                              textField: {
                                helperText: enderrorMessage,
                                required: true,
                                onFocus: () => {
                                  if (enderror === null && endDate === null) {
                                    setEndDate(moment());
                                    setenddisabled(false);
                                  }
                                },
                              },
                            }}
                            minDate={startDate}
                            maxDate={maxDate}
                          />
                        </Box>
                      </LocalizationProvider>
                    </Grid>
                  ) : null}
                  <Grid item xs={12} md={1.5} sm={4} alignItems="center">
                    <Box
                      sx={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      {dateenable ? (
                        <>
                          <Tooltip title="Filter" placement="bottom">
                            <Fab
                              disabled={
                                startdisabled === true || enddisabled === true
                                  ? true
                                  : false
                              }
                              size="small"
                              sx={{
                                color: "white",
                                backgroundColor: "#339fcd",
                                boxShadow: 0,
                                "&:hover": { backgroundColor: "#217396" },
                              }}
                              onClick={() => {
                                handleClickFilter(getApi, startDate, endDate);
                              }}
                            >
                              <CheckRoundedIcon />
                            </Fab>
                          </Tooltip>
                          <Tooltip title="Refresh" placement="bottom">
                            <Fab
                              size="small"
                              sx={{
                                color: "white",
                                backgroundColor: "#339fcd",
                                boxShadow: 0,
                                "&:hover": { backgroundColor: "#217396" },
                              }}
                              onClick={() => {
                                setFilterPosition("");
                                handleClickRefresh(getApi);
                              }}
                            >
                              <RefreshSharpIcon />
                            </Fab>
                          </Tooltip>
                        </>
                      ) : null}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={1.5} sm={2} alignItems="center">
                    <>
                      <Box display="flex">
                        <Tooltip title="Export As Excel" placement="bottom">
                          <ExportCS
                            selectedApiForExcel={selectedApiForExcel}
                            fileName={"Advertise-History"}
                          />
                        </Tooltip>
                        <Tooltip title="Export As PDF" placement="bottom">
                          <ExportPDF
                            headers={headers}
                            datas={datas}
                            fileName={"Advertise-History"}
                          />
                        </Tooltip>
                      </Box>
                    </>
                  </Grid>
                  <Grid item xs={12} sm={2} md={2.5}>
                    <FormControl
                      sx={{ width: { md: "100%", xs: "100%", sm: "100%" } }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Filter By Position
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={filterPosition}
                        label="Filter By Position"
                        onChange={(e) => {
                          setFilterPosition(e.target.value);
                          handleSelectPosition(getApi, e.target.value);
                        }}
                      >
                        <MenuItem value={"popupimage"}>Popup Ad</MenuItem>
                        <MenuItem value={"topimage"}>Top Ad</MenuItem>
                        <MenuItem value={"bottomimagefooter"}>
                          Bottom Ad
                        </MenuItem>
                        <MenuItem value={"sideimageright"}>
                          Side Ad Right
                        </MenuItem>
                        <MenuItem value={"sideimageleft"}>
                          Side Ad Left
                        </MenuItem>
                        <MenuItem value={"centerimage"}>Center Ad</MenuItem>
                        <MenuItem value={"bottomimage"}>Flash Ad</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
            <TableContainer
              component={Paper}
              sx={{ marginTop: "10px", boxShadow: 0, maxHeight: 440 }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow className="table-row">
                    <TableCell> Ad Image</TableCell>
                    <TableCell> Company URL</TableCell>
                    <TableCell>Ad Position</TableCell>
                    <TableCell> Days Valid</TableCell>
                    <TableCell> Created Date</TableCell>
                    <TableCell align="center"> Total Amount</TableCell>
                    <TableCell align="center"> Received Amount</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center"> Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {useApi.length > 0 ? (
                    <>
                      {useApi

                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((item) => (
                          <TableRow key={item._id} hover className="tablecell">
                            <TableCell>
                              {" "}
                              {
                                <img
                                  src={
                                    item?.addUpload
                                      ? `${baseUrl}advertisement/advertisement/image/${item._id}/users`
                                      : ""
                                  }
                                  onError={(e) => {
                                    e.target.src = defaultimg;
                                  }}
                                  onClick={() => {
                                    setGetOne(item._id);
                                    setOpenAd(true);
                                  }}
                                  alt="img"
                                  height={"50"}
                                  width="50"
                                  style={{ clipPath: "circle(50%)" }}
                                />
                              }{" "}
                            </TableCell>
                            <TableCell>{item.company_url}</TableCell>
                            <TableCell align="left">
                              {" "}
                              {item.image_position === "bottomimagefooter"
                                ? "Bottom Ad"
                                : item.image_position === "popupimage"
                                ? "Popup Ad"
                                : item.image_position === "bottomimage"
                                ? "Flash Ad"
                                : item.image_position === "topimage"
                                ? "Top Ad"
                                : item.image_position === "sideimageright"
                                ? "Side Ad Right"
                                : item.image_position === "sideimageleft"
                                ? "Side Ad Left"
                                : "Center Ad"}{" "}
                            </TableCell>

                            <TableCell>{item.days_conut}</TableCell>
                            <TableCell>{item.createdDate}</TableCell>
                            <TableCell align="center">
                              {item.total_amount}
                            </TableCell>
                            <TableCell align="center">
                              {item.received_amount}
                            </TableCell>
                            <TableCell align="center">
                              <Tooltip
                                title={
                                  item.status === "Open" ? "Open" : "Closed"
                                }
                                placement="right"
                              >
                                <Chip
                                  label={item.status}
                                  color={
                                    item.status === "Open" ? "success" : "error"
                                  }
                                  variant="contained"
                                />
                              </Tooltip>
                            </TableCell>
                            <TableCell align="center">
                              <Tooltip
                                title={item.status === "Open" ? "Off" : "On"}
                                placement="top"
                              >
                                <Switch
                                  checked={
                                    item.status === "Open" ? true : false
                                  }
                                  onChange={(e) => {
                                    updateASettings(e.target.checked, item._id);
                                    setConfirmCloseAd(true);
                                  }}
                                />
                              </Tooltip>

                              <Tooltip title="Delete" placement="top">
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    getOneData(item._id);
                                    setOpenDelete(true);
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                    </>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>
                          {" "}
                          <Typography
                            variant="body1"
                            sx={{ fontFamily: "Barlow-Bold" }}
                          >
                            NO Data Available
                          </Typography>
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Box>
        <Dialog
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "#339fcd",
              borderRadius: "20px",
            },
          }}
          open={confirmCloseAd}
          fullWidth
        >
          <Box>
            <Box>
              <DialogContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "space-around",
                    height: "100%",
                  }}
                >
                  <Box sx={{ paddingTop: "10px" }}>
                    <Warning height={100} width={100} />
                  </Box>
                  <Typography
                    variant="h4"
                    sx={{ paddingTop: "10px", fontFamily: "Poppins-SemiBold" }}
                  >
                    {" "}
                    Are you sure?
                  </Typography>
                  <Typography
                    sx={{
                      paddingTop: "10px",
                      fontFamily: "Poppins-Medium",
                      color: "white",
                    }}
                  >
                    Once you Submitted,You can't modify your advertisement
                  </Typography>

                  <Box
                    sx={{
                      paddingTop: "20px",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                      width: "100%",
                    }}
                  >
                    <Button
                      onClick={() => {
                        setConfirmCloseAd(false);
                      }}
                      variant="outlined"
                      sx={{
                        backgroundColor: "#f2f2f2",
                        textTransform: "lowercase",

                        color: "black",
                        borderColor: "white",
                        fontFamily: "Poppins-Medium",
                        "&:hover": {
                          textTransform: "lowercase",
                          color: "#f2f2f2",
                          backgroundColor: "#339fcd",
                          borderColor: "#f2f2f2",
                          fontFamily: "Poppins-Medium",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="outlined"
                      sx={{
                        textTransform: "lowercase",

                        color: "white",
                        backgroundColor: "#ed1067",
                        borderColor: "#ed1067",
                        fontFamily: "Poppins-Medium",
                        transition: "all 0.3s",
                        "&:hover": {
                          textTransform: "lowercase",

                          color: "#ed1067",
                          borderColor: "#ed1067",
                          fontFamily: "Poppins-Medium",
                        },
                      }}
                      onClick={() => {
                        setConfirmCloseAd(false);
                        fetchApi();
                      }}
                    >
                      Confirm
                    </Button>
                  </Box>
                </Box>
              </DialogContent>
            </Box>
          </Box>
        </Dialog>
        <Dialog
          open={openAd}
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "rgb(16 143 178)",
            },
          }}
        >
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            Advertisement full view
          </DialogTitle>
          <DialogContent
            style={{
              width: "100%",
              padding: "5px",
              alignItems: "center",
            }}
          >
            <img
              style={{ width: "100%", height: "100%" }}
              src={
                getOne
                  ? `${baseUrl}advertisement/advertisement/image/${getOne}/users`
                  : ""
              }
              onError={(e) => {
                e.target.src = defaultimg;
              }}
              alt="img"
            />
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => setOpenAd(false)}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "#339fcd",
              borderRadius: "20px",
            },
          }}
          open={openDelete}
          fullWidth
          onClose={() => setOpenDelete(false)}
        >
          <Box>
            <Box>
              <DialogContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "space-around",
                    height: "100%",
                  }}
                >
                  <Box sx={{ paddingTop: "10px" }}>
                    <Warning height={100} width={100} />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{ paddingTop: "10px", fontFamily: "Poppins-SemiBold" }}
                  >
                    {" "}
                    Are you sure want to delete this advertisement?
                  </Typography>
                  <Typography
                    sx={{
                      paddingTop: "10px",
                      fontFamily: "Poppins-Medium",
                      color: "white",
                    }}
                  >
                    You can't undo this action
                  </Typography>

                  <Box
                    sx={{
                      paddingTop: "20px",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                      width: "100%",
                    }}
                  >
                    <Button
                      onClick={() => {
                        setOpenDelete();
                      }}
                      variant="outlined"
                      sx={{
                        backgroundColor: "#f2f2f2",
                        textTransform: "lowercase",
                        color: "black",
                        borderColor: "white",
                        fontFamily: "Poppins-Medium",
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="outlined"
                      sx={{
                        textTransform: "lowercase",
                        color: "#ed1067",
                        borderColor: "#ed1067",
                        fontFamily: "Poppins-Medium",
                        "&:hover": {
                          textTransform: "lowercase",
                          color: "white",
                          backgroundColor: "#ed1067",
                          borderColor: "#ed1067",
                          fontFamily: "Poppins-Medium",
                        },
                      }}
                      onClick={() => {
                        deleteUser(getOneAdDetails._id);
                      }}
                    >
                      Delete{" "}
                    </Button>
                  </Box>
                </Box>
              </DialogContent>
            </Box>
          </Box>
        </Dialog>
      </>
    );
  } else {
    return (
      <>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Card sx={{ padding: "20px", borderRadius: "20px" }}>
            <Skeleton
              animation="wave"
              variant="text"
              width={230}
              height={40}
              sx={{ borderRadius: "15px" }}
            />
          </Card>
          <Card
            sx={{
              borderRadius: "20px",

              padding: "20px",

              height: "500px",
              gap: "20px",
            }}
          >
            <Skeleton variant="rounded" />
            <Skeleton variant="rounded" width="100%" height="300px" />
          </Card>
        </Box>
      </>
    );
  }
}

export default AdminAdvertisementSettings;
